module.exports = __webpack_public_path__ + "img/archeological-dig.ba0782ea.png";